import React, { Component } from 'react';
import { Link,withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import axios from 'axios';
import { apiUrl, mediaUrl} from'../Config/Config';
import Select from 'react-select';
import Multiselect from 'multiselect-react-dropdown';
import { lang } from '../Helpers/lang';
import CKEditor from 'ckeditor4-react';

import PlacesAutocomplete, {
	geocodeByAddress,
	getLatLng,
  }  from 'react-places-autocomplete';
import { PageTitle, CheckAuth, scrollToTopValidate, scrollToTop } from "../Helpers/SettingHelper";

		
class Edit extends Component {
	fileObj = [];
    fileArray = [];
    imageArray = [];
	constructor(props)
	{
		CheckAuth();
		super(props);	
		
		const id = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;
		this.state =  { 
			id: id,
			name:'',
			email:'',
			phoneno:'',
			status:'',
			description:'',
			selectedDomain:'',
			domainlist:[],
			specialist:[],
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'',
			domain_id:'',
			specialist_id:'',
			dont_distrub_checked:false,
			image:'',
			image_name: '',
			image_preview: '',address:'',
			locationlist: [{id: '', name: 'Select Your Location'}],
			providerlist: [{id: '', name: 'Select Provider'}],
			insurancelist: [{id: '', name: 'Select Insurence'}],
			amenitieslist: [{id: '', name: 'Select Insurence'}],
			
			locationselectedList:[],
			providerselectedList:[],
			insuranceselectedList:[],
			amenitiesselectedList:[],
			avalibility:'',
			hoursofoperation:'',
			tab_image:[],
			galleryimg:1,
			galleries: '',
			selectid:'',
			imagepath:'',
			selected_image:'',
			type:'',
		}
		
	    this.handleInputChange = this.handleInputChange.bind(this);
       	this.handleChange = this.handleChange.bind(this);
		this.onChangeHandler = this.onChangeHandler.bind(this);
		this.onEditorChangedescription = this.onEditorChangedescription.bind(this);
		this.onEditorChangehoursofoperation = this.onEditorChangehoursofoperation.bind(this);		
		this.uploadMultipleFiles = this.uploadMultipleFiles.bind(this);
    }

	
	uploadMultipleFiles = (e) =>{
		this.fileObj = [];
	
			this.fileObj.push(e.target.files)
			for (let i = 0; i < this.fileObj[0].length; i++) {
				this.fileArray.push(URL.createObjectURL(this.fileObj[0][i]))
				//this.fileArray.push(this.fileObj[0][i]
				this.imageArray.push(this.fileObj[0][i])
	
			}
			
			this.setState({ tab_image: this.imageArray,galleryimg:2 })		
		}

		removeImagebyindex = (indexvalue) => {
		   
			var list = [...this.imageArray];
			this.imageArray = [];
			this.fileArray = [];
			list.splice(indexvalue, 1);
		   
			for (let i = 0; i < list.length; i++) {
			  this.imageArray.push(list[i]);
			  this.fileArray.push(URL.createObjectURL(list[i]));
			}
		  
			  this.setState({ tab_image: this.imageArray })	
	  }
	onEditorChangedescription( evt ) {
    	var callfunc = this;
    	setTimeout(function () {
			callfunc.setState( {
				description: evt.editor.getData()
			});
		},1000);     
    }
	onEditorChangehoursofoperation( evt ) {
    	var callfunc = this;
    	setTimeout(function () {
			callfunc.setState( {
				hoursofoperation: evt.editor.getData()
			});
		},1000);     
    }


	handleInputChange(event) {
		const {name, value} = event.target;      
		this.setState({
			[name]: value
		  });
		if(name == 'dont_distrub'){
			this.setState({dont_distrub_checked: !this.state.dont_distrub_checked})
		}
	  }
    handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };
	onChangeHandler=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		reader.onloadend = () => {
		  this.setState({
			image_name: file.name,
			image_preview: reader.result,
			image: file
		  });
		};
		reader.readAsDataURL(file);
	}

	componentDidMount() {
		
		const today = new Date().toISOString().split('T')[0];  
		// Set max attribute to today's date
		document.getElementById('establish_on').setAttribute('max', today);

		document.title = PageTitle('Edit Traveler');
		if(localStorage.getItem('admin_id') === null){
			this.props.history.push('/');
		}		
		axios.get(apiUrl+'traveler/listdetail?id='+this.state.id)		
		.then(res => {
			if(res.data.status == 'success'){
			
					const formdata = res.data.clinicdata;
				
					// this.setState({ });

					// locationselectedValue:[{id: '1', name: 'Japan, Fukuoka, Chuo Ward, Izaki, 4, SSDS'},{id: '3', name: 'Mexico'}]	

					if(res.data.locationlist!=undefined && res.data.locationlist!=''  ){					
						this.setState({
							locationselectedValue:res.data.locationlist,

						});
					}

					if(res.data.providerlist!=undefined && res.data.providerlist!=''  ){					
						this.setState({providerselectedValue:res.data.providerlist,});
					}

					if(res.data.insurancelist!=undefined && res.data.insurancelist!=''  ){					
						this.setState({insuranceselectedValue:res.data.insurancelist,});
					}

					if(res.data.amenitieslist!=undefined && res.data.amenitieslist!=''  ){					
						this.setState({amenitiesselectedValue:res.data.amenitieslist,});
					}

					this.setState({ galleries: res.data.imageslist }, () => {
					});

					if(formdata.status === 'A'){
						this.setState({selectedOption:{value: 'active', label: 'Active'},selectedvalue:'active'});
					}else{
						this.setState({selectedOption:{value: 'inactive', label: 'Inactive'},selectedvalue:'inactive'});
					}
					// if(parseInt(formdata.dont_distrub) === 0){
					// 	this.setState({dont_distrub_checked: false});
					// }else{
					// 	this.setState({dont_distrub_checked: true});
					// }
					// if(formdata.certificate_verified =='No'){
					// 	this.setState({certificate_verified_checked:false});
					// }else{
					// 	this.setState({certificate_verified_checked:true});
					// }
					// var specialist_id='';
					// if(formdata.specialist!=undefined ){					
					// 	specialist_id = formdata.specialist;
					// }
					this.setState({image_preview:mediaUrl+'traveler/'+formdata.image,image_name:formdata.image,name:formdata.name,email:formdata.email,phoneno:formdata.phone,id: formdata.id,cost: parseInt(formdata.cost),location: formdata.location, description: formdata.description,hoursofoperation:formdata.hoursofoperation,establish_on:formdata.establish_on});		
					let Img1 = '';
					let preview1 = '';
					// if (formdata.certificate!== null && formdata.certificate!== '') {
					// 	Img1 = doctorURL + "/" + formdata.certificate;
					// 	preview1 =<a href={Img1} className="preview-img" target='_blank'><img className="img_class" style={{width:'70px',height:'70px'}} src={Img1} alt="" /></a>;
					// 	this.setState({name_img1:formdata.certificate})
					// }else{
					// 	this.setState({name_img1:''})
					// } 
					this.setState({
						preview1:preview1
					});
				}else{
			
			}
		});

		var admin_id = localStorage.getItem('admin_id');
	
			
		axios.get(apiUrl+'traveler/getlocation?admin_id='+admin_id)		
		.then(res => {
			if(res.data.status == 'success'){			
				this.setState({
					locationlist: [].concat(res.data.location)
				})			
			}else{
			
			}
		});	
		axios.get(apiUrl+'traveler/getdoctor?admin_id='+admin_id)		
		.then(res => {
			if(res.data.status == 'success'){			
				this.setState({
					providerlist: [].concat(res.data.doctor)
				})			
			}else{
			
			}
		});	
		axios.get(apiUrl+'traveler/getinsurance?admin_id='+admin_id)		
		.then(res => {
			if(res.data.status == 'success'){			
				this.setState({
					insurancelist: [].concat(res.data.insurence)
				})			
			}else{
			
			}
		});	

		axios.get(apiUrl+'traveler/getamenities?admin_id='+admin_id)		
		.then(res => {
			if(res.data.status == 'success'){			
				this.setState({
					amenitieslist: [].concat(res.data.amenities)
				})			
			}else{
			
			}
		});	
    }

	 handleFormSubmit = () => {
			if(this.validateForm()){
				this.setState({Loading:true});
				var qs = require('qs');
				const formPayload = this.state;
			    var status = '';				
				const config = {
					headers: {
						'content-type': 'multipart/form-data'
					}
				}
				if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				status =formPayload.selectedOption.value;
				}else{
				status = formPayload.selectedvalue;
				}				
				var dontditrub = 0;
				if(this.state.dont_distrub_checked == true){
					var dontditrub = 1;
				}
			
				const locationselectedList = formPayload.locationselectedList;
				var elements=[];
				var elements1=[];
				let locList  = ''
				if(locationselectedList!=='' && typeof locationselectedList!==undefined && locationselectedList!==null) {
					locList = locationselectedList.map((number) =>
						elements.push(number.id)
						
					);
					locList = locationselectedList.map((number) =>
						elements1.push(number.name.replace(/[,]/g,' '))
					);
				}
				const locationselectedLists=elements.toString();
				const locationselectedLists1=elements1.toString();
				// --------------------------------------

				const providerselectedList = formPayload.providerselectedList;
				var providerelements=[];
				var providerelements1=[];
				let providerList  = ''
				if(providerselectedList!=='' && typeof providerselectedList!==undefined && providerselectedList!==null) {
					locList = providerselectedList.map((number) =>
						providerelements.push(number.id)
						
					);
					locList = providerselectedList.map((number) =>
						providerelements1.push(number.name.replace(/[,]/g,' '))
					);
				}
				const providerselectedLists=providerelements.toString();
				const providerselectedLists1=providerelements1.toString();
				// --------------------------------------

				const insuranceselectedList = formPayload.insuranceselectedList;
				var insuranceelements=[];
				var insuranceelements1=[];
				let insuranceList  = ''
				if(insuranceselectedList!=='' && typeof insuranceselectedList!==undefined && insuranceselectedList!==null) {
					console.log(insuranceselectedList,'insuranceselectedList');
					locList = insuranceselectedList.map((number) =>
						insuranceelements.push(number.id)						
					);
					locList = insuranceselectedList.map((number) =>
						insuranceelements1.push(number.name.replace(/[,]/g,' '))
					);
				}
				const insuranceselectedLists=insuranceelements.toString();
				const insuranceselectedLists1=insuranceelements1.toString();

				// ---------------------------------------------------------------

				
				const amenitiesselectedList = formPayload.amenitiesselectedList;
				var amenitieselements=[];
				var amenitieselements1=[];
				let amenitiesList  = ''
				if(amenitiesselectedList!=='' && typeof amenitiesselectedList!==undefined && amenitiesselectedList!==null) {
					amenitiesList = amenitiesselectedList.map((number) =>
						amenitieselements.push(number.id)						
					);
					amenitiesList = amenitiesselectedList.map((number) =>
						amenitieselements1.push(number.name.replace(/[,]/g,' '))
					);
				}
				const amenitiesselectedLists=amenitieselements.toString();
				const amenitiesselectedLists1=amenitieselements1.toString();
				
				// ---------------------------------------------------------------
				var postObject = {
			        admin_id : localStorage.getItem("admin_id"),
					// domain_id : formPayload.domain_id,
					clinic_id: formPayload.id,
					name     : formPayload.name,
					// graduation: formPayload.graduation,
					description: formPayload.description,
					// specialist    : formPayload.specialist_id,
					// experience_yr     : formPayload.experience,
					email        : formPayload.email,
					phoneno      : formPayload.phoneno,
					location: formPayload.location,
					cost: formPayload.cost,
					establish_on: formPayload.establish_on,
					hoursofoperation: formPayload.hoursofoperation,
					// dont_distrub: dontditrub,
					status       :  status,
					image : formPayload.image,
					locationselectedid:locationselectedLists,
					locationselectedname:locationselectedLists1,					
					providerselectedid:providerselectedLists,
					providerselectedname:providerselectedLists1,					
					insuranceselectedid:insuranceselectedLists,
					insuranceselectedname:insuranceselectedLists1,	
					amenitiesselectedid:amenitiesselectedLists,
					amenitiesselectedname:amenitiesselectedLists1,	

					avalibility:formPayload.avalibility
				};
				let formData = new FormData();
				for(let k in postObject) {
					formData.append(k, postObject[k]);
				}

				var filesdata = this.state.tab_image;
						var galleryimg = this.state.galleryimg;
						if(galleryimg==2){
						for (var i in filesdata) {
							formData.append('multiple_images[]',filesdata[i])
						}
					}   
					// console.log(formData,'formData');
				axios.post(apiUrl+"traveler/edit",formData,config).then(res => {
					if(res.data.status === "success"){	
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
						scrollToTop();
								setTimeout(
								function() {
									$('.success_message').html(this.props.history.push('/traveler'));
								}
								.bind(this),
								5000
								);
					}else{
						if(res.data.status === "erroremail"){

							$('.erroremail').html('<span class="errorspan">'+res.data.message+'</span>');
								scrollToTop();
								   setTimeout(
								   function() {
									   $('.erroremail').html('');
								   }
								   .bind(this),
								   5000
								   );
						   }else if(res.data.status === "errorphone"){
	   
							$('.errorphoneno').html('<span class="errorspan">'+res.data.message+'</span>');
								scrollToTop();
								   setTimeout(
								   function() {
									   $('.errorphoneno').html('');
								   }
								   .bind(this),
								   5000
								   );
						   }else if(res.data.status === "errorusername"){
	   
							$('.errorusername').html('<span class="errorspan">'+res.data.message+'</span>');
								scrollToTop();
								   setTimeout(
								   function() {
									   $('.errorusername').html('');
								   }
								   .bind(this),
								   10000
								   );
						   }else{
							   $('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
							   scrollToTop();
							   setTimeout(
							   function() {
								   $('.success_message').html('');
							   }
							   .bind(this),
							   3000
							   );
						   }
						
					}
					this.setState({Loading:false});
				});
			}
	}

	validateForm() {
		const {name,email,phoneno,location,cost} = this.state;
		let errors = 0;
		if (!name) {
			errors++;
			$('.errorname').html('<span class="errorspan">Please fill the field</span>');
		}else if(name){
			$('.errorname').html('');
		}

		// if(!avalibility){
		// 	errors++;
		// 	$('.erroravalibility').html('<span class="errorspan">Please fill the field</span>');
		// }else if(avalibility){
		// 	$('.erroravalibility').html('');
		// }

		// if (!domain_id) {
		// 	errors++;
		// 	$('.errorassign_domain').html('<span class="errorspan">Please select the field</span>');
		// }else if(domain_id){
		// 	$('.errorassign_domain').html('');
		// }

		// if (!specialist) {
		// 	errors++;
		// 	$('.errorspecialist').html('<span class="errorspan">Please select specialist</span>');
		// }else if(specialist){
		// 	$('.errorspecialist').html('');
		// }

		// if (!graduation) {
		// 	errors++;
		// 	$('.errorgraduation').html('<span class="errorspan">Please fill the field</span>');
		// }else if(graduation){
		// 	$('.errorgraduation').html('');
		// }
		if (!email) {
	    	errors++;			
			$('.erroremail').html('<span class="errorspan">Please fill the field</span>');
		}else if(email){
			var reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
		    // var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
		    if (reg.test(email) == false) 
	        {
				errors++;				
	            $('.erroremail').html('<span class="errorspan">Please enter valid email address</span>');
	        }else{
	        	$('.erroremail').html('');
	        }
		}
		// if (!phoneno) {
		// 	errors++;
		// 	$('.errorphoneno').html('<span class="errorspan">Please fill the field</span>');
		// }else if(phoneno){
		// 	$('.errorphoneno').html('');
		// }

		if (!phoneno) {
			errors++;
			$('.errorphoneno').html('<span class="errorspan">Phone number is required</span>');
		  }else if(phoneno){	
			var pattern = /^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
			var indiapattern =/^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/;
			if (pattern.test(phoneno)) {
			$('.errorphoneno').html('');
			}else if(indiapattern.test(phoneno)){
			$('.errorphoneno').html('');
			}else{
				errors++;
				$('.errorphoneno').html('<span class="errorspan">Please enter valid phone number</span>');
			}
		}	

		if (!location) {
			errors++;
			$('.errorlocation').html('<span class="errorspan">Please fill the field</span>');
		}else if(location){
			$('.errorlocation').html('');
		}	

		if (!cost) {
			errors++;
			$('.errorcost').html('<span class="errorspan">Please fill the field</span>');
		}else if(cost){
			$('.errorcost').html('');
		}

		// if (!experience) {
		// 	errors++;
		// 	$('.errorexperience').html('<span class="errorspan">Please fill the field</span>');
		// }else if(experience){
		// 	$('.errorexperience').html('');
		// }

		


		if(errors>0) {
		setTimeout(function () {
		scrollToTopValidate();
		}, 100);
		return false;
		}
		else {
		return true;
		}

		/*this.setState({
			errors: errors
		});
		return formIsValid;*/
    }
	handleClickSelecet = (event) => {
		const selectedIndex = event.target.options.selectedIndex;
		var key = event.target.options[selectedIndex].getAttribute('data-key');

		this.setState({
				domain_id: key,
				
		})


	}

	handlespecialist = (event) => {
		const selectedIndex = event.target.options.selectedIndex;
		var key = event.target.options[selectedIndex].getAttribute('data-key');

		this.setState({
			specialist_id: key,
				
		})
	}
	  
	
	handleChangeaddress = location => {
		this.setState({ location });
	  };
	 
	  handleSelect = location => {

		geocodeByAddress(location)
		  .then(results => getLatLng(results[0]))
		  .then(latLng => console.log('Success', latLng))
		  .catch(error => console.error('Error', error));
		  this.setState({ location });
	  };

	onSelect = selectedList=>{		
		this.setState({locationselectedList:selectedList});		
	}
	
	onRemove = selectedList =>{
		this.setState({locationselectedList:selectedList});	
	}

	onSelectProvider = selectedList=>{		
		this.setState({providerselectedList:selectedList});		
	}	
	onRemoveProvider = selectedList =>{
		this.setState({providerselectedList:selectedList});	
	}

	onSelectInsurence = selectedList=>{		
		this.setState({insuranceselectedList:selectedList});		
	}	
	onRemoveInsurence = selectedList =>{
		this.setState({insuranceselectedList:selectedList});	
	}

	onSelectAmenities = selectedList=>{		
		this.setState({amenitiesselectedList:selectedList});		
	}	
	onRemoveAmenities = selectedList =>{
		this.setState({amenitiesselectedList:selectedList});	
	}


	
confirmPopup = (id,imagepath,selected_image,type) => {
	this.setState({selectid: id,imagepath:imagepath,selected_image:selected_image, type: type})	
	$('.confirm-action').addClass('show');		
}
deleteimage(){
	var qs = require('qs');
	var postObject = {
	  admin_id : localStorage.getItem("admin_id"),
	  gallery_id  :this.state.selectid,
	  clinic_id :this.state.id,
	  imagepath  :this.state.imagepath,
	  selected_image  :this.state.selected_image,
	  type: this.state.type
	};
	axios.post(apiUrl+"traveler/deletegalleryimage",qs.stringify(postObject)).then(res => {      
		  if(res.data.status === 'success'){			
			this.setState({ galleries: res.data.imageslist }, () => {
			});
			$('.success_message').html('<div class="status_sucess"><h3> '+ res.data.message +' </h3></div>');
			setTimeout(function() {
				$('.success_message').html('');   
			}.bind(this),3000);
		  }
	}); 
}
Confirmstatus = (confirmstatus) => {
	if(confirmstatus == 'yes'){
	  this.deleteimage();
	  $('.confirm-action').removeClass('show');
	}else{
	  $('.confirm-action').removeClass('show');	
	}  
}

  render() {	
  	const {selectedOption,domainlist, specialist} = this.state;
	var current = this;	
	let imageslist = [];
	let indexlength =  imageslist.length;
	const gallerylocal =  this.fileArray && this.fileArray.map((url,index) => (
		<li className="thumb" key={indexlength+index}  >
			<img src={url}  alt="..." />
			<a href="javascript:void(0);" onClick={this.removeImagebyindex.bind(this,index)}>X</a>
		</li>));

    return (
      <div className="wrapper"> 
 
	  <Header />
    <MenuSidebar currentpage="traveler" />  

	
	<div className="content">	
		<div className="content-wrapper">
		        <div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">

			<div className="success_message"></div>
			<div>
				<a className="cursor-pointer btn-arrow" href="/traveler">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800.48 613.46"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 800.48 613.46)"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -199.77 906.72003)"><path d="m857.14 640.38-221.02 225.27-4.25-665.88-65.172 1.4141-1.418 667.3-223.85-226.68-48.172 48.172 306.02 310.27 307.44-311.69z" fillRule="evenodd"/></g></g></svg>
				</a>
			</div>
			<div className="title">
				<h4>Edit Traveler</h4>
			</div>
			{/* onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} */}
		<form className="login" id="login" >
		<div className="form-row">
				<div className="form-left">
					<div className="form-group">
						<label>Traveler Name<span class="required" style={{ color: "red" }} > * </span>:</label>
						<input type="text" name="name" onChange={this.handleInputChange} className="form-control" value={this.state.name} />
						<div className="errorname"></div>
					</div>
					
					<div className="form-group">
						<label>Contact Number(999 999 9999)<span class="required" style={{ color: "red" }} > * </span>:</label>
						<input type="text" name="phoneno" onChange={this.handleInputChange} className="form-control" value={this.state.phoneno} />
						<div className="errorphoneno"></div>
					</div>

						<div className="form-group">
							<label>Booking Fee($)<span class="required" style={{ color: "red" }} > * </span>:</label>
							<input type="number" name="cost" onChange={this.handleInputChange} className="form-control" value={this.state.cost} autoComplete="off"/>
							<div className="errorcost"></div>
					    </div>

						{/* <div className="form-group">
							<label>Providers :</label>
							<Multiselect
							options={this.state.providerlist} // Options to display in the dropdown
							 selectedValues={this.state.providerselectedValue} 
							 // Preselected value to persist in dropdown
							onSelect={this.onSelectProvider} // Function will trigger on select event
							onRemove={this.onRemoveProvider} // Function will trigger on remove event
							displayValue="name" // Property name to display in the dropdown options
							/>
					    </div> */}
						<div className="form-group">
							<label>Insurance :</label>
							<Multiselect
							options={this.state.insurancelist} // Options to display in the dropdown
							selectedValues={this.state.insuranceselectedValue} 
							 // Preselected value to persist in dropdown
							onSelect={this.onSelectInsurence} // Function will trigger on select event
							onRemove={this.onRemoveInsurence} // Function will trigger on remove event
							displayValue="name" // Property name to display in the dropdown options
							/>
					    </div>
					

					{/* <div className="form-group">					
						<label>Specialist <span class="required" style={{ color: "red" }} > * </span>: </label>
						<select  onChange={current.handlespecialist}  value={specialist.cat_name}>                    
						{this.state.specialist.map((specialist) => <option key={specialist.value} data-key={specialist.value} value={specialist.value} >{specialist.label}</option>)}
						</select>	
						<div className="errorassign_domain"></div>
					</div>

					<div className="form-group">					
						<label>INsurence <span class="required" style={{ color: "red" }} > * </span>: </label>
						<select  onChange={current.handlespecialist}  value={specialist.cat_name}>                    
						{this.state.specialist.map((specialist) => <option key={specialist.value} data-key={specialist.value} value={specialist.value} >{specialist.label}</option>)}
						</select>	
						<div className="errorassign_domain"></div>
					</div> */}

					{/* <div className="form-group">
							<label>Years of experience<span class="required" style={{ color: "red" }} > * </span>:</label>
							<input type="text" name="experience" onChange={this.handleInputChange} className="form-control" value={this.state.experience} autoComplete="off"/>
							<div className="errorexperience"></div>
					</div> */}

					
				  
				  

				   	{/* <div className="form-group">
							<input onChange={this.handleInputChange} type="checkbox"  name="dont_distrub" checked={this.state.dont_distrub_checked}/>
							<label> Don't distrub </label>
					</div> */}
					
					<div className="form-group">
						<label>Establish On:</label>
						<input type="date" id="establish_on" name="establish_on" onChange={this.handleInputChange} className="form-control" value={this.state.establish_on} autoComplete="off"/>
						<div className="errorestablish_on"></div>
					</div>

					<div className="form-group">					
						<label>About Clinic:</label>
								<CKEditor
									data={this.state.description}
									//data={templatecontent}
									onChange={this.onEditorChangedescription}
									type="classic"
								/> 
							{/* <textarea type="text" name="description" onChange={this.handleInputChange} className="form-control" value={this.state.description}  /> */}
						<div className="errordescription"></div>
				   </div>

					<div className="default-font">
						<div className="form-group">					
							<label>Status:</label>
								<Select 
								value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
									options={lang.common.status_option} 
									onChange={this.handleChange}
									/>
						</div>
					</div>

				</div>
				<div className="form-right">
					<div className="form-group">
						<label>Upload Traveler Image:</label>
						<div className="choose-file">
						{this.state.isHidden && <div className="image_success"></div>}
						<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
						</div>
						
						{(this.state.image_preview!='' &&this.state.image_name)&& <img src={this.state.image_preview} width={100} height={100} /> }
						{/* {loader_image_preview?<a href="javascript:void(0);">X</a>:''} */}
						<div className="errorloaderimage"></div>  
					</div> 

					  	<div className="form-group">
							<label>Email<span class="required" style={{ color: "red" }} > * </span>:</label>
								<input type="text" name="email" onChange={this.handleInputChange} className="form-control" value={this.state.email} autoComplete="off" />
							<div className="erroremail"></div>
						</div>
						
						<div className="form-group">
							<label>Traveler Venue<span class="required" style={{ color: "red" }} > * </span>:</label>
							<PlacesAutocomplete	value={this.state.location}	onChange={this.handleChangeaddress}	onSelect={this.handleSelect}			>
								{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
								<div>
									<input  type="text" name="location" className="form-control" value={this.state.location}	
									{...getInputProps({
										placeholder: 'Search Places ...',
										className: 'location-search-input',
									})}
									/>
									<div className="autocomplete-dropdown-container">
									{loading && <div>Loading...</div>}
									{suggestions.map(suggestion => {
										const className = suggestion.active
										? 'suggestion-item--active'
										: 'suggestion-item';
										// inline style for demonstration purpose
										const style = suggestion.active
										? { backgroundColor: '#fafafa', cursor: 'pointer' }
										: { backgroundColor: '#ffffff', cursor: 'pointer' };
										return (
										<div
											{...getSuggestionItemProps(suggestion, {
											className,
											style,
											})}
										>
											<span>{suggestion.description}</span>
										</div>
										);
									})}
									</div>
								</div>
								)}
							</PlacesAutocomplete>
							<div className="errorlocation"></div>
					    </div>

						

						{/* <div className="form-group">					
							<label>Assign Domain<span class="required" style={{ color: "red" }} > * </span>: </label>
							<select  onChange={current.handleClickSelecet}  value={domainlist.domain_name}>                    
							{this.state.domainlist.map((domainlist) => <option key={domainlist.value} data-key={domainlist.value} value={domainlist.value} >{domainlist.label}</option>)}
							</select>	
							<div className="errorassign_domain"></div>
						</div> */}

						<div className="form-group">
							<label>Amenities :</label>
							<Multiselect
							options={this.state.amenitieslist} // Options to display in the dropdown
							 selectedValues={this.state.amenitiesselectedValue} 
							 // Preselected value to persist in dropdown
							onSelect={this.onSelectAmenities} // Function will trigger on select event
							onRemove={this.onRemoveAmenities} // Function will trigger on remove event
							displayValue="name" // Property name to display in the dropdown options
							/>
					    </div>
						
						{/*<div className="form-group">
							<label>Preferred Location:</label>
							<Multiselect
							options={this.state.locationlist} // Options to display in the dropdown
							 selectedValues={this.state.locationselectedValue} 
							 // Preselected value to persist in dropdown
							onSelect={this.onSelect} // Function will trigger on select event
							onRemove={this.onRemove} // Function will trigger on remove event
							displayValue="name" // Property name to display in the dropdown options
							/>
					    </div> */}

						

						{/* <div className="form-group">
							<label>Location:</label>
							<input type="text" name="location" onChange={this.handleInputChange} className="form-control" value={this.state.location} autoComplete="off"/>
							<div className="errorlocation"></div>
					    </div> */}
					

						

						<div className="form-group">
							<label>Hours of operation:</label>
							{/* <input type="text" name="venue" onChange={this.handleInputChange} className="form-control" value={this.state.venue} autoComplete="off"/> */}

							<CKEditor
									data={this.state.hoursofoperation}
									//data={templatecontent}
									onChange={this.onEditorChangehoursofoperation}
									type="classic"
								/> 

							<div className="errorevenue"></div>
					    </div>

						<div className="form-group">
					<label>Upload Gallery (jpeg,jpg,png,svg)<span class="required" style={{ color: "red" }} ></span>:</label>
					<div className="choose-file">
					
					<span className="profile_btn"><input type="file" name="file" onChange={this.uploadMultipleFiles} multiple /></span>
					</div>
					<ul className="carimagelisting">
						{gallerylocal}
					</ul>
					{this.state.galleries!=''?
						<div className="form-group">
							<div className='gallery-main clinic'>
								<label>Galleries</label>
								<div className='gallery-container'>
									{this.state.galleries?.map((item) => (
									<div className='gallery-inner' key={item.id}>
										<img width="100px" height="100px" src={mediaUrl+'/'+'clinic'+'/'+item.image} alt={`Image ${item.id}`}  />
											<Link onClick={this.confirmPopup.bind(this, item.id,item.image_path,item.image,'gallery')} className="" title="Delete">X</Link>
									</div>
									))}
								</div>
							</div>
						</div>:''}	
					</div> 

						
					</div>
				</div>

				<div className="btn-group export">	
					<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}   onClick={e => { this.handleFormSubmit(this); e.preventDefault(); }}  > {this.state.Loading ===true ?<span>Loading</span>:<span>Submit</span>  }
					</button>
				</div>
			</form>
			</div>
				
		</div>	
	</div>
	<div className="confirm-action">
					<p>Are you sure! you want to delete this image?</p>
					<a href="javascript://" onClick={this.Confirmstatus.bind(this, "yes")} className="btn">Yes</a>
					<a href="javascript://" onClick={this.Confirmstatus.bind(this, "no")} className="btn">No</a>
				</div>	
    </div>
    );
  }
}

export default withRouter(Edit);